import { RecoveryCode } from '../model/types'
import { RequestResponse, secureRequest, url } from '../utils/request-utils'

export function fetchRecoveryCodes(): Promise<RequestResponse<RecoveryCode[]>> {
  return secureRequest('GET', url('/v2/recoveryCodes'))
}
